
import _ from 'lodash';

// logo foncia colors
// #dab6d4 #eb690b
// #7780b8 #00925b #f8b322
// #003f7d #0091b4 #39b6b8


export function buildSecteurAffecteEtab(etabs, metier) {
    let secteurAffecte = {};
    etabs.forEach(e => {
        if (Array.isArray(e[metier]))
            e[metier].forEach(commune => secteurAffecte[commune.code] = e);
    });
    return secteurAffecte;
}


export function buildAllSecteursCd(societe, metier, collabs) {
    let allSecteursCd = {};
    societe.agences.forEach(etab => {
        if (Array.isArray(etab[metier]))
            etab[metier].forEach(affectation => allSecteursCd[affectation.code] = findCollabsById(collabs, affectation.refIndividu));
    });
    return allSecteursCd;
}

export function getCurrentAffectationsDuCd(societe, metier, cd) {
    let affectations = [];
    societe.agences.forEach(etab => {
        if (Array.isArray(etab[metier]))
        etab[metier].forEach(affectation => {
            if(affectation.refIndividu && affectation.refIndividu === cd.idIndividu)
            affectations.push(affectation);
        });
    });
    return affectations;
}

export function getDefaultStyle() {

    let defaultStyle = {
        'color': 'grey',
        'Ile-de-France': {'fillColor': '#FFF200', 'fillOpacity': 0.3},
        'Nord-Est': {'fillColor': '#FF8484', 'fillOpacity': 0.3},
        'Sud-Est': {'fillColor': '#c8bfe7', 'fillOpacity': 0.6},
        'Sud-Ouest': {'fillColor': '#00A2E8', 'fillOpacity': 0.3},
        'Ouest': {'fillColor': '#22B14C', 'fillOpacity': 0.3}
    };

    return defaultStyle;
}

function findCollabsById(collabs, idCollab) {
    return _.find(collabs, {idIndividu: idCollab});
}





